import { render, staticRenderFns } from "./resume-detail.vue?vue&type=template&id=670991c1"
import script from "./resume-detail.vue?vue&type=script&lang=js"
export * from "./resume-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports